var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',{attrs:{"action":"/"}},[_c('van-search',{attrs:{"show-action":"","clearable":"","placeholder":_vm.placeholder},on:{"clear":_vm.onClear,"search":_vm.onSearch,"cancel":_vm.onCancel},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }